import React from 'react'

const ArrivalIndicator = ({info}) => {
  return (
    <>
      <div className="arrival-time" style={{
      gridColumn: `${1} / span ${1}`,
      gridRow: `${info.startRow+2} / span ${info.height}`
    }}></div>

    <div className="arrival-time-line top" style={{
      gridColumn: `${2} / span ${100}`,
      gridRow: `${info.startRow+2}`,
      width: '100%',
      height: '100%'
    }}></div>
    <div className="arrival-time-line bottom" style={{
      gridColumn: `${2} / span ${100}`,
      gridRow: `${info.startRow+info.height+2}`,
      width: '100%',
      height: '100%'
    }}></div>
      <span className="arrival-title" style={{
         gridColumn: `${1} / span ${2}`,
         gridRow: `${info.startRow+2} / span ${info.height}`
      }}><h4>Arrival Time</h4></span>
    </>
  )
}

export default ArrivalIndicator
